import script from "./FretboardTooltipContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FretboardTooltipContent.vue?vue&type=script&setup=true&lang=ts"

import "./FretboardTooltipContent.vue?vue&type=style&index=0&id=be8acd80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be8acd80"]])

export default __exports__